import "./ButtonComponent.css";
import { buttonClassName, ButtonComponentProps } from "./ButtonHelpers";

const ButtonComponent = (props: ButtonComponentProps) => {
  return (
    <button
      className={buttonClassName(props.selected, props.name, props.isDisabled)}
      onClick={props.isDisabled ? () => {} : props.onClick}
      disabled={props.isDisabled}
    >
      {props.name}
    </button>
  );
};

export default ButtonComponent;
